var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PaneHeaderButton_1 = require("./PaneHeaderButton");
var SplitPaneIcon_1 = require("./SplitPaneIcon");
var PaneHeader_styled_1 = require("./PaneHeader_styled");
var types_1 = require("../types");
var PaneHeader = /** @class */ (function (_super) {
    __extends(PaneHeader, _super);
    function PaneHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.splitHorizontally = function (e) {
            e.stopPropagation();
            _this.props.splitPane(types_1.PaneSplitAxis.Horizontal);
        };
        _this.splitVertically = function (e) {
            e.stopPropagation();
            _this.props.splitPane(types_1.PaneSplitAxis.Vertical);
        };
        return _this;
    }
    PaneHeader.prototype.render = function () {
        var _a = this.props, pane = _a.pane, contentTypes = _a.contentTypes, setCurrentContent = _a.setCurrentContent, removeContent = _a.removeContent;
        return (React.createElement(PaneHeader_styled_1.Container, null,
            React.createElement(PaneHeader_styled_1.Buttons, null, pane.contents.map(function (content) { return (React.createElement(PaneHeaderButton_1.default, { key: content.id, pane: pane, content: content, contentTypes: contentTypes, setCurrentContent: setCurrentContent, removeContent: removeContent })); })),
            pane.contents.length > 0 && (React.createElement(PaneHeader_styled_1.SplitButtons, null,
                React.createElement(SplitPaneIcon_1.default, { axis: "horizontal", onClick: this.splitHorizontally }),
                React.createElement(SplitPaneIcon_1.default, { axis: "vertical", onClick: this.splitVertically })))));
    };
    return PaneHeader;
}(React.Component));
exports.default = PaneHeader;
